import { css } from '@emotion/react'
import {
  Button,
  type ButtonProps,
  SpacingToken,
} from '@livechat/design-system-react-components'

import { getProductDesignation } from '@/store/selectors'
import useParamSelector from '@/hooks/useParamSelector'
import { getDesignationLabel, getProductIFrameUrl } from '@/utils/products'
import InactiveLicense from '../NotInstallable/InactiveLicense'

export const btnCss = css`
  white-space: nowrap;
  margin-right: var(${SpacingToken.Spacing2});
`

interface Props extends ButtonProps {
  id: string
  onlyPrimaryButton?: boolean
}

export const TryProductButton = ({ id, onlyPrimaryButton, size }: Props) => {
  const designation = useParamSelector(getProductDesignation, id)
  const url = getProductIFrameUrl(designation)
  const handleClick = () => window.open(url, '_blank')

  return (
    <>
      <InactiveLicense
        designation={designation}
        label="Buy"
        size={onlyPrimaryButton ? size : 'medium'}
        fullWidth
      />
      {!onlyPrimaryButton && (
        <Button
          data-test="buy-btn"
          kind="text"
          onClick={handleClick}
          fullWidth
          css={btnCss}
        >
          Try {getDesignationLabel(designation)}
        </Button>
      )}
    </>
  )
}

export default TryProductButton
